module.exports = __webpack_public_path__ + "img/instructions_settings.57972493.png";